import { Component, OnInit, EventEmitter } from '@angular/core';
import { GeneralFormComponent } from '../../controls/general-form/general-form.component';

@Component({
  selector: 'app-recovery-external-pqrs-password',
  templateUrl: './recovery-external-pqrs-password.component.html',
  styleUrls: ['./recovery-external-pqrs-password.component.scss']
})
export class RecoveryExternalPqrsPasswordComponent extends GeneralFormComponent implements OnInit {

  Verificarbtn: any;
  Recuperarbtn: any;
  Cancelarbtn: any;
 

  public OnInitEnd() {
    debugger;
    this.Verificarbtn = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Comprobar" });
    this.Recuperarbtn = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Recuperar" });
    this.Cancelarbtn = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Cancelar" });
  }


  public OnActionEventHandler(event) {
    debugger;
    switch (event.ControlType) {

      case 'Button': {
        switch (event.Name) {
          case 'Comprobar': {
            debugger;

            if((this.modelo.modelo.IdTipoIdentificacion != null && this.modelo.modelo.IdTipoIdentificacion != undefined) && (this.modelo.modelo.NumeroIdentificacion != null && this.modelo.modelo.NumeroIdentificacion != undefined && this.modelo.modelo.NumeroIdentificacion != '') && (this.modelo.modelo.CorreoContacto != null && this.modelo.modelo.CorreoContacto != undefined && this.modelo.modelo.CorreoContacto != ''))
            {
              var obj = this.utility.GetApiModel('ConsultaRecuperacionContrasenaPqrs', this.componentName);

            obj.QueryConfig.Command = 'ConsultaRecuperacionContrasenaPqrs';
            obj.QueryConfig.IsSp = true;
            debugger;
            obj.QueryConfig.Entity = { IdTipoIdentificacion: this.modelo.modelo.IdTipoIdentificacion, Identificacion: this.modelo.modelo.NumeroIdentificacion, CorreoContacto: this.modelo.modelo.CorreoContacto };
            // obj.QueryConfig.Entity = (esEdicion) ? { IdTablaRetencionDocumental: this.modelo.modelo.IdTablaRetencionDocumental } : this.modelo.modeloCascada;
            // this.baseService.showLoadNotifyType =true;
            this.baseService.Get(obj, null,
              {
                componentName: this.componentName,
                method: 'ConsultaRecuperacionContrasenaPqrs',
                processMessage: 'Verificando datos de usuario...'
              }, 'RContacto')
              .then(data => {
                debugger;
                if (data.Data[0].Message != null || data.Data[0].Message != undefined) {
                  this.utility.VerModalWarning({
                    titulo: 'Alerta', descripcion: data.Data[0].Message,
                    verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
                  }).then(data => { });
                }
                else {
                  this.modelo.modelo.DataAdd = {
                    NombreCompleto: data.Data[0].NombreCompleto,
                    Password: atob(data.Data[0].Password),
                    CorreoContacto: this.modelo.modelo.CorreoContacto
                  }  
                  this.utility.VerModalInfo({
                    titulo: 'Verificación correcta', descripcion: 'Sr(a). ' + data.Data[0].NombreCompleto + ' para continuar con el proceso de recuperación de contraseña realice clic en el botón Recuperar',
                    verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
                  }).then(data => { });
                  this.Recuperarbtn.Hidden = false; 
                  this.Verificarbtn.Hidden = true;  
                  this.Cancelarbtn.Hidden = false;             
                }

              }).catch(err => {
                this.utility.logger.LogError(err, obj, {
                  componentName: this.componentName,
                  method: 'ConsultaRecuperacionContrasenaPqrs',
                  processMessage: 'Verificando datos de usuario...'
                }, 'General')
              });
            
            }
            else
            {
              this.utility.VerModalWarning({
                titulo: 'Alerta', descripcion: 'Por favor ingrese sus datos para continuar',
                verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
              }).then(data => { });
            }

            break
          };
          case 'Recuperar': {
            this.utility.VerModalInfo({
              titulo: 'Proceso ejecutado correctamente', descripcion: 'Se ha enviado la información solicitada al correo electrónico ingresado.',
              verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
            }).then(data => { });
            this.Recuperarbtn.Hidden = true;
            this.Verificarbtn.Hidden = false;
            this.Cancelarbtn.Hidden = true;
            break;
          };
          case 'Cancelar': {
            var CurrentUrl = window.location.href;
            window.location.href = CurrentUrl.replace('RecuperarContrasena', 'HomeExternalPQR');
            break;
          };
        }
        break
      };
    }
    super.OnActionEventHandler(event);
  }

}
